import React, { useEffect, useState } from 'react';
import { useModal } from '../../hooks/modalContext';
import { Building2, ChevronLeft } from 'lucide-react';
import { getBuildingDetails } from '../../../auth/_requests';
import { useAuth } from '../../../auth/Auth';
import { buildingDetails } from '../../utils/types';
import SVGChecked from '../../SVG/SVGRadio/SVGChecked';
import SVGUnchecked from '../../SVG/SVGRadio/SVGUnchecked';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { openPayRentFlowOrModals } from '../../utils/payFlowGuard';

const SelectProperty: React.FC = () => {
  const { setModal, modalState } = useModal();
  const { paymentType } = modalState || {};
  const { auth } = useAuth();
  const navigate = useNavigate();
  const [properties, setProperties] = useState<buildingDetails[]>([]);
  const [propertySelectedId, setPropertySelectedId] = useState<string>('');

  useEffect(() => {
    const fetchProperties = async () => {
      const response = await getBuildingDetails(auth?.data?.token);
      const allProps = response?.data || [];

      let filteredProperties = allProps.filter(
        (property: any) =>
          property.building.isActive &&
          property.building.rentAmount > 500 &&
          (property.building.payNumber || property.building.tenantManager)
      );

      if (modalState?.fromModal === 'enable-reporting') {
        filteredProperties = filteredProperties.filter(
          (property: any) => !property.equifaxUserData
        );
      }

      setProperties(filteredProperties);

      if (filteredProperties.length === 1) {
        setPropertySelectedId(filteredProperties[0].building.tenantBuildingId);
      }
    };

    fetchProperties();
  }, [auth?.data?.token, paymentType]);

  const handlePropertySelect = (id: string) => {
    const newValue = propertySelectedId === id ? '' : id;
    setPropertySelectedId(newValue);
  };

  return (
    <motion.div
      className='relative w-[554px] max-h-[675px] bg-[#FFF] rounded-[12px] flex flex-col overflow-auto'
      initial='hidden'
      animate='visible'
      exit='exit'
    >
      <div className='flex flex-col px-10 py-4'>
        <div className='flex items-center gap-2 mb-4 mt-4'>
          <ChevronLeft
            onClick={() => {
              setModal(null);
              if (modalState?.fromModal === 'enable-reporting') {
                setModal('enable-reporting');
              } else {
                setModal('rewards');
              }
            }}
            className='cursor-pointer text-gray-500 hover:text-gray-700'
          />
          <span className='text-main text-lg'>
            {modalState?.fromModal === 'enable-reporting' ? 'Set up autopay' : 'Pay rent for '}{' '}
          </span>
        </div>

        <div className='flex-col items-center justify-center '>
          {properties.length !== 0 ? (
            <>
              <div>
                {properties.map((property) => (
                  <div
                    className='flex items-center gap-2 p-4 cursor-pointer hover:bg-gray-50 border border-gray-200 rounded-lg mb-2'
                    key={property.building.tenantBuildingId}
                    onClick={() => handlePropertySelect(property.building.tenantBuildingId)}
                  >
                    {propertySelectedId === property.building.tenantBuildingId ? (
                      <SVGChecked />
                    ) : (
                      <SVGUnchecked />
                    )}
                    <div className='text-main base font-medium'>
                      {property.building.buildingName}
                      {property.address?.fullAddress ? `  ${property.address.fullAddress}` : ''}
                    </div>
                  </div>
                ))}
              </div>
              <button
                onClick={() => {
                  void openPayRentFlowOrModals(
                    propertySelectedId,
                    properties,
                    setModal,
                    navigate,
                    'pay-now',
                    paymentType === 'subscription' ? 'autopay' : 'direct'
                  );
                }}
                className='submitBtn mb-8 mt-8 '
                disabled={!propertySelectedId}
              >
                Continue
              </button>
            </>
          ) : (
            <div className='flex flex-col items-center text-center text-gray-500 py-10'>
              <Building2 size={48} className='mb-4 text-gray-400' />
              <p className='text-lg font-semibold'>No properties available</p>
              <p className='text-sm text-gray-400'>
                You don't have any properties eligible for this offer yet.
              </p>
            </div>
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default SelectProperty;
